import createNamedContext from "./createNamedContext";

const historyContext = /*#__PURE__*/ createNamedContext("Router-History");
export default historyContext;
